import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilitaService } from '../../services/utilita.service';

@Component({
  selector: 'app-visualizza-dettaglio-tabella',
  templateUrl: './visualizza-dettaglio-tabella.component.html',
  styleUrls: ['./visualizza-dettaglio-tabella.component.css']
})
export class VisualizzaDettaglioTabellaComponent implements OnInit {
  objdettaglio: any;
  idutente: any;
  titolo: string = '';
  lstElencoNominativi: any;
  obj: any;
  idRichiesta: any;
  idUtenteRichiesta = '';

  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<VisualizzaDettaglioTabellaComponent>,
    private snackBar: MatSnackBar, private route: ActivatedRoute, private router: Router,
    private srvUtilita: UtilitaService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.titolo = 'Dettagli Richiesta Adesione'
    this.route.queryParams.subscribe((params: any) => {
      const id = params['id'];
        
      this.idRichiesta = id;

      console.log('iValore pagina', id)
    })
  }


  ngOnInit(): void {
     this.getListaNominativi();
    this.getDettaglio();
  }

  getDettaglio() {
    this.srvUtilita.getObj('Utenti/GetRichiesta?idRichiesta=' + this.idRichiesta).subscribe((res: any) => {
      this.obj = res
      // console.log(res, 'res')
    })
  }
   
  getListaNominativi() {
    this.srvUtilita.getLista('Utenti/GetElencoNominativi?iIdRichiesta=' + this.idRichiesta).subscribe((res: any) => {
      this.lstElencoNominativi = res
      // console.log(res, 'res')
    })
  }

  btnAnnulla() {
    this.router.navigate(['/dashboard/'])

  }

}
